<script>
import LoginCandidateWide from "../../atoms/Login/LoginCandidateWide.vue";

export default {
    name: "RecentLogins",
    components: {LoginCandidateWide},
    props: {
        candidates: {
            type: Array,
            required: true
        }
    }
}
</script>

<template>
    <div class="welcome-card-illustration d-none d-lg-flex flex-column w-100 p-5">
        <img alt="Logo" src="/img/logo.svg" width="150">
        <h1 class=" mt-3">{{ trans('general.page.login.recent_login.title') }}</h1>
        <p class="label">{{ trans('general.page.login.recent_login.description') }}</p>

        <div class="d-flex flex-wrap candidates gap-3 mt-2">
            <div class="w-auto" v-for="candidate in candidates" :key="candidate.id">
                <login-candidate-wide v-on="$listeners" :candidate="candidate"/>
            </div>
        </div>
    </div>
</template>
